import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgCorrectionIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <g clipPath="url(#correction-icon_svg__a)">
      <path
        fill="currentColor"
        d="M44.137 9.6a3.2 3.2 0 0 1 4.525 0l5.738 5.737a3.2 3.2 0 0 1 0 4.526l-33.6 33.6a3.2 3.2 0 0 1-2.263.937H12.8a3.2 3.2 0 0 1-3.2-3.2v-5.738a3.2 3.2 0 0 1 .937-2.262l16.8-16.8zm-3.475 8 5.738 5.737 5.737-5.737-5.737-5.737zm3.475 8L38.4 19.863l-25.6 25.6V51.2h5.737z"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={2.2}
        d="M39.013 2H6a4 4 0 0 0-4 4v52a4 4 0 0 0 4 4h52a4 4 0 0 0 4-4V27.548"
      />
    </g>
    <defs>
      <clipPath id="correction-icon_svg__a">
        <path fill="#fff" d="M0 0h64v64H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgCorrectionIcon
